<template>
    <div class="main">
        <img src="../assets/about/background/0.webp" alt="" class="background">
        <div class="contentWrap">
            <div class="mainTitle">ABOUT US</div>
            <!-- <div class="dash"></div> -->
            <div class="brief">
                <b>Allvita</b> is committed to developing and manufacturing high-quality, innovative veterinary products designed to create healthier futures for your pets. We focus on delivering products that truly make a difference in pet health, underpinned by continuous research and development, all while maintaining the highest manufacturing standards. Our product range includes a variety of formats such as oral powders, oral solutions, injectables, sprays, spot-ons, tablets, chewables, boluses, ointments, pastes, and collars—each one carefully crafted in APVMA-approved facilities.
            </div>
            <div class="brief">
                To ensure that Australian pet owners have easy access to our innovative products, Allvita partners with industry leaders and leverages our own patented technologies. We adopt a multi-channel distribution approach, making our products readily available through online stores, e-commerce platforms, partnerships with veterinary clinics, and retail distribution, ensuring that pets around the world benefit from our solutions.
            </div>
        </div>
        <img src="../assets/about/background/1.webp" alt="" class="background">
        <page-footer style="z-index: 8; position: absolute; bottom: 0; left: 0;"></page-footer>
    </div>
</template>

<script>
import PageFooter from "./PageFooter.vue";

export default {

    components: {
            PageFooter,
        },

}
</script>

<style lang="scss" scoped>
.main {
  padding-top: $navBarHeight;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  .background {
    width: 100%;
    height: auto;
  }

  .contentWrap {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0 15%;
    margin-bottom: 5rem;

    .mainTitle {
        font-size: 3.5rem;
        margin-top: 4rem;
        font-family: "Montserrat", serif;
        font-weight: 700;
        color: #2C2B2B;
    }

    .brief {
        font-size: 1.36rem;
        font-family: "Montserrat", serif;
        font-weight: 400;
        margin-top: 1.8rem;
        line-height: 2.4rem;
        color: #2C2B2B;
    }
  }
}

@media (max-width: 768px) {
    .main {
        padding-top: 4rem;
        padding-bottom: 2rem;

        .contentWrap {
            padding: 0 1.5rem;
            margin-bottom: 2rem;
            
            .mainTitle {
                font-size: 1.8rem;
                margin-top: 2rem;
                text-align: center;
                margin-bottom: 0.5rem;
            }
            
            .brief {
                font-size: 1rem;
                line-height: 1.6rem;
                text-align: justify;
                margin-top: 1.2rem;
            }
        }
    }
}

</style>